// removed by extract-text-webpack-plugin
module.exports = {"MenuItem":"_2ncnY_c-TdpN6i8rVzcTLh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/MenuItem/MenuItem.css
// module id = 658
// module chunks = 0